/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GameModelDto } from '../models/game-model-dto';
import { PlayByPlayModelGameDto } from '../models/play-by-play-model-game-dto';
import { scoutingControllerEventsBulkActions } from '../fn/scouting/scouting-controller-events-bulk-actions';
import { ScoutingControllerEventsBulkActions$Params } from '../fn/scouting/scouting-controller-events-bulk-actions';
import { scoutingControllerGetEventsWithVideo } from '../fn/scouting/scouting-controller-get-events-with-video';
import { ScoutingControllerGetEventsWithVideo$Params } from '../fn/scouting/scouting-controller-get-events-with-video';
import { scoutingControllerGetTeamGamesWithVideo } from '../fn/scouting/scouting-controller-get-team-games-with-video';
import { ScoutingControllerGetTeamGamesWithVideo$Params } from '../fn/scouting/scouting-controller-get-team-games-with-video';
import { scoutingControllerGetTeamsWithVideo } from '../fn/scouting/scouting-controller-get-teams-with-video';
import { ScoutingControllerGetTeamsWithVideo$Params } from '../fn/scouting/scouting-controller-get-teams-with-video';
import { TeamWithVideoDto } from '../models/team-with-video-dto';

@Injectable({ providedIn: 'root' })
export class ScoutingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scoutingControllerGetTeamsWithVideo()` */
  static readonly ScoutingControllerGetTeamsWithVideoPath = '/scouting/teams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerGetTeamsWithVideo()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamsWithVideo$Response(params?: ScoutingControllerGetTeamsWithVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamWithVideoDto>>> {
    return scoutingControllerGetTeamsWithVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerGetTeamsWithVideo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamsWithVideo(params?: ScoutingControllerGetTeamsWithVideo$Params, context?: HttpContext): Observable<Array<TeamWithVideoDto>> {
    return this.scoutingControllerGetTeamsWithVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TeamWithVideoDto>>): Array<TeamWithVideoDto> => r.body)
    );
  }

  /** Path part for operation `scoutingControllerGetTeamGamesWithVideo()` */
  static readonly ScoutingControllerGetTeamGamesWithVideoPath = '/scouting/{teamUuid}/games';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerGetTeamGamesWithVideo()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamGamesWithVideo$Response(params: ScoutingControllerGetTeamGamesWithVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GameModelDto>>> {
    return scoutingControllerGetTeamGamesWithVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerGetTeamGamesWithVideo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamGamesWithVideo(params: ScoutingControllerGetTeamGamesWithVideo$Params, context?: HttpContext): Observable<Array<GameModelDto>> {
    return this.scoutingControllerGetTeamGamesWithVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GameModelDto>>): Array<GameModelDto> => r.body)
    );
  }

  /** Path part for operation `scoutingControllerGetEventsWithVideo()` */
  static readonly ScoutingControllerGetEventsWithVideoPath = '/scouting/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerGetEventsWithVideo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerGetEventsWithVideo$Response(params: ScoutingControllerGetEventsWithVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelGameDto>>> {
    return scoutingControllerGetEventsWithVideo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerGetEventsWithVideo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerGetEventsWithVideo(params: ScoutingControllerGetEventsWithVideo$Params, context?: HttpContext): Observable<Array<PlayByPlayModelGameDto>> {
    return this.scoutingControllerGetEventsWithVideo$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayByPlayModelGameDto>>): Array<PlayByPlayModelGameDto> => r.body)
    );
  }

  /** Path part for operation `scoutingControllerEventsBulkActions()` */
  static readonly ScoutingControllerEventsBulkActionsPath = '/scouting/events/bulk/{action}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerEventsBulkActions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerEventsBulkActions$Response(params: ScoutingControllerEventsBulkActions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return scoutingControllerEventsBulkActions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerEventsBulkActions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerEventsBulkActions(params: ScoutingControllerEventsBulkActions$Params, context?: HttpContext): Observable<void> {
    return this.scoutingControllerEventsBulkActions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
